import {
  DecisionPageLayout,
  DecisionSection,
  DecisionSubHeading,
  DecisionList,
  InlineRelatedLinks,
} from "@/components/DecisionPageLayout";
import { Link } from "@/lib/router-compat";

const seo = {
  title:
    "Depression Treatment for First Responders | Neuro Wellness TMS Centers of America",
  description:
    "First responders with depression: learn about treatment options including TMS, SAINT, SPRAVATO, and ketamine when medication hasn't worked.",
  canonical: "/depression-treatment-for-first-responders",
  keywords:
    "depression treatment first responders, first responder depression Florida, TMS depression first responders, SAINT depression first responder",
};

const relatedLinks = [
  { title: "TMS for First Responders", href: "/tms-for-first-responders" },
  {
    title: "Mental Health Treatment for First Responders",
    href: "/mental-health-treatment-for-first-responders",
  },
  {
    title: "First Responder Insurance Verification",
    href: "/first-responder-insurance-verification",
  },
  { title: "TMS for Depression", href: "/services/depression" },
];

export default function DepressionTreatmentForFirstResponders() {
  return (
    <DecisionPageLayout
      seo={seo}
      badge="First Responder Depression"
      title="Depression Treatment for First Responders"
      subtitle="If you're a first responder whose depression hasn't responded to medication, there are other options that work through different mechanisms."
    >
      <DecisionSection heading="Depression in first responders">
        <p>
          Depression in first responders often looks different than it does in
          the general population. It may show up as irritability, emotional
          numbing, withdrawal from family, or a growing sense that nothing
          matters. It's not always sadness — sometimes it's the absence of
          feeling.
        </p>
        <p>
          If you've tried one or more antidepressants without adequate relief,
          there's a clinical term for where you are: treatment-resistant
          depression. It's common, and there are treatments designed
          specifically for it.
        </p>
      </DecisionSection>

      <DecisionSection heading="Treatment options">
        <DecisionList
          items={[
            "TMS — FDA-cleared, non-invasive, targets specific brain regions",
            "SAINT accelerated TMS — five-day protocol with fMRI targeting",
            "SPRAVATO (esketamine) — FDA-approved for treatment-resistant depression",
            "IV ketamine infusions — rapid-acting, for depression and suicidal ideation",
            "Ketamine-assisted psychotherapy (KAP)",
            "Trauma-informed psychotherapy",
            "Medication management",
          ]}
        />
      </DecisionSection>

      <DecisionSection heading="Your next step">
        <p>
          Call{" "}
          <a
            href="tel:9548279793"
            className="text-accent font-semibold hover:underline"
          >
            (954) 827-9793
          </a>{" "}
          or{" "}
          <Link
            to="/first-responder-insurance-verification"
            className="text-accent hover:underline"
          >
            verify your insurance
          </Link>
          .
        </p>
      </DecisionSection>

      <InlineRelatedLinks heading="Related Pages" links={relatedLinks} />
    </DecisionPageLayout>
  );
}
